import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function About() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace('#', ''));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location]);

  return (
    <>
      <SchemaOrg type="WebPage" data={{
        name: '51漫画网 - 关于我们',
        description: '了解51漫画网品牌介绍、用户口碑及联系方式。51漫画网是漫迷首选的在线阅读平台。',
        url: 'https://www.51manhua.com/about',
      }} />
      <SchemaOrg type="FAQPage" data={{
        mainEntity: [
          {
            '@type': 'Question',
            name: '51漫画网是什么？',
            acceptedAnswer: { '@type': 'Answer', text: '51漫画网是一个提供高清漫画在线阅读的平台，涵盖热血、恋爱、奇幻、搞笑等多种类型的漫画资源，是漫迷首选的在线阅读平台。' },
          },
          {
            '@type': 'Question',
            name: '51漫画网安全吗？',
            acceptedAnswer: { '@type': 'Answer', text: '51漫画网提供官方安全入口，所有内容经过严格审核，确保用户阅读安全。网站采用HTTPS加密传输，保护用户隐私。' },
          },
          {
            '@type': 'Question',
            name: '如何在51漫画网阅读漫画？',
            acceptedAnswer: { '@type': 'Answer', text: '直接访问51漫画网官网入口（51manhua.com），浏览首页推荐或通过分类查找感兴趣的漫画，点击即可开始阅读。无需注册，完全免费。' },
          },
          {
            '@type': 'Question',
            name: '51漫画网是否支持手机阅读？',
            acceptedAnswer: { '@type': 'Answer', text: '支持。51漫画网网页版已针对手机、平板等移动设备进行优化，用户可以随时随地通过浏览器访问51漫画网址进行阅读。' },
          },
        ],
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <div className="pt-20 pb-10">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <Breadcrumb items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]} />

            <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 font-bold mt-4 mb-2">
              关于51漫画网
            </h1>
            <p className="text-foreground-500 text-sm">
              安全、高清、免费的漫画在线阅读平台
            </p>

            {/* Brand Introduction */}
            <section id="brand" className="mt-10">
              <h2 className="text-xl font-heading text-foreground-950 font-bold mb-4 flex items-center gap-2">
                <i className="ri-building-2-line text-primary-500"></i>
                品牌介绍
              </h2>
              <div className="bg-background-100 rounded-lg p-6">
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  <strong className="text-foreground-900">51漫画网</strong>成立于2018年，是国内领先的漫画在线阅读平台。我们致力于为广大漫迷提供<strong>安全、高清、免费</strong>的漫画阅读体验。经过多年的发展，51漫画网已经积累了超过<strong>10,000部</strong>优质漫画资源，覆盖热血、恋爱、奇幻、搞笑、动作、悬疑、科幻、恐怖等多种类型。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  51漫画网始终坚持<strong>用户至上</strong>的理念，不断优化阅读体验。51漫画网页版采用了先进的技术架构，确保页面加载迅速、画质清晰流畅。无论你是使用电脑、平板还是手机访问51漫画网址，都能获得一致的优质阅读体验。
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  作为51漫画官方平台，我们严格把控内容质量，所有漫画资源均经过精心筛选和整理。51漫画官网版提供安全可靠的访问入口，让用户远离恶意网站和广告骚扰，安心享受漫画带来的乐趣。
                </p>
              </div>
            </section>

            {/* Reputation */}
            <section id="reputation" className="mt-10">
              <h2 className="text-xl font-heading text-foreground-950 font-bold mb-4 flex items-center gap-2">
                <i className="ri-thumb-up-line text-accent-500"></i>
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map(i => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    &ldquo;用了51漫画网好几年了，资源非常丰富，更新也很快。网页版和手机版体验都很好，推荐给所有漫迷！&rdquo;
                  </p>
                  <p className="text-xs text-foreground-500">—— 资深漫迷 张先生</p>
                </div>
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map(i => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    &ldquo;51漫画网站入口稳定，从来没有遇到过打不开的情况。高清画质看起来特别过瘾，是我每天必刷的平台。&rdquo;
                  </p>
                  <p className="text-xs text-foreground-500">—— 漫迷 李同学</p>
                </div>
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4, 5].map(i => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    &ldquo;分类清晰，找漫画特别方便。51漫画网页版的界面设计也很简洁干净，没有乱七八糟的广告，体验很好。&rdquo;
                  </p>
                  <p className="text-xs text-foreground-500">—— 王老师</p>
                </div>
                <div className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-2">
                    {[1, 2, 3, 4].map(i => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                    <i className="ri-star-half-line text-yellow-400 text-sm"></i>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    &ldquo;作为一个漫画老书虫，51漫画官网版满足了我对阅读体验的所有要求。更新快、画质好、免费看，还能要求什么呢？&rdquo;
                  </p>
                  <p className="text-xs text-foreground-500">—— 漫迷 小赵</p>
                </div>
              </div>
            </section>

            {/* FAQ */}
            <section id="faq" className="mt-10">
              <h2 className="text-xl font-heading text-foreground-950 font-bold mb-4 flex items-center gap-2">
                <i className="ri-question-answer-line text-secondary-500"></i>
                常见问题
              </h2>
              <div className="space-y-3">
                <details className="bg-background-100 rounded-lg p-5 group cursor-pointer">
                  <summary className="text-sm font-semibold text-foreground-900 list-none flex items-center justify-between">
                    51漫画网是什么？
                    <i className="ri-arrow-down-s-line transition-transform group-open:rotate-180 text-foreground-500"></i>
                  </summary>
                  <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                    51漫画网是一个提供高清漫画在线阅读的平台，涵盖热血、恋爱、奇幻、搞笑等多种类型的漫画资源，是漫迷首选的在线阅读平台。
                  </p>
                </details>
                <details className="bg-background-100 rounded-lg p-5 group cursor-pointer">
                  <summary className="text-sm font-semibold text-foreground-900 list-none flex items-center justify-between">
                    51漫画网安全吗？
                    <i className="ri-arrow-down-s-line transition-transform group-open:rotate-180 text-foreground-500"></i>
                  </summary>
                  <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                    51漫画网提供官方安全入口，所有内容经过严格审核，确保用户阅读安全。网站采用HTTPS加密传输，保护用户隐私。
                  </p>
                </details>
                <details className="bg-background-100 rounded-lg p-5 group cursor-pointer">
                  <summary className="text-sm font-semibold text-foreground-900 list-none flex items-center justify-between">
                    如何在51漫画网阅读漫画？
                    <i className="ri-arrow-down-s-line transition-transform group-open:rotate-180 text-foreground-500"></i>
                  </summary>
                  <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                    直接访问51漫画网官网入口（51manhua.com），浏览首页推荐或通过分类查找感兴趣的漫画，点击即可开始阅读。无需注册，完全免费。
                  </p>
                </details>
                <details className="bg-background-100 rounded-lg p-5 group cursor-pointer">
                  <summary className="text-sm font-semibold text-foreground-900 list-none flex items-center justify-between">
                    51漫画网是否支持手机阅读？
                    <i className="ri-arrow-down-s-line transition-transform group-open:rotate-180 text-foreground-500"></i>
                  </summary>
                  <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                    支持。51漫画网网页版已针对手机、平板等移动设备进行优化，用户可以随时随地通过浏览器访问51漫画网址进行阅读。
                  </p>
                </details>
                <details className="bg-background-100 rounded-lg p-5 group cursor-pointer">
                  <summary className="text-sm font-semibold text-foreground-900 list-none flex items-center justify-between">
                    51漫画网漫画多久更新一次？
                    <i className="ri-arrow-down-s-line transition-transform group-open:rotate-180 text-foreground-500"></i>
                  </summary>
                  <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
                    51漫画网上的漫画更新频率根据作品不同有所差异，热门漫画通常每日更新，部分作品每周更新2-3话。您可以在51漫画官网版首页查看最新更新列表。
                  </p>
                </details>
              </div>
            </section>

            {/* Contact */}
            <section id="contact" className="mt-10">
              <h2 className="text-xl font-heading text-foreground-950 font-bold mb-4 flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                联系我们
              </h2>
              <div className="bg-background-100 rounded-lg p-6">
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  如果您对51漫画网有任何建议、意见或合作意向，欢迎通过以下方式联系我们。我们将尽快回复您的消息。
                </p>
                <div className="flex flex-col gap-3 text-sm">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <span className="text-foreground-600">客服邮箱：</span>
                    <strong className="text-foreground-900">service@51manhua.com</strong>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                      <i className="ri-customer-service-line text-accent-600"></i>
                    </div>
                    <span className="text-foreground-600">商务合作：</span>
                    <strong className="text-foreground-900">business@51manhua.com</strong>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100">
                      <i className="ri-map-pin-line text-secondary-600"></i>
                    </div>
                    <span className="text-foreground-600">公司地址：</span>
                    <strong className="text-foreground-900">北京市朝阳区望京SOHO T2-B座 1208室</strong>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}